module.exports = flarum.core.compat['components/Link'];